import { Store } from '@nextforce/api'
import { ListItem, makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'

interface Props {
  store?: Store
  isSelected: boolean
  showAllStoresOptionName?: string
  onSelect?: (store: Store) => void
}

export function StoreItem({
  store,
  isSelected,
  onSelect,
  showAllStoresOptionName,
}: Props) {
  const styles = useStyles()

  return (
    <ListItem containerStyle={styles.container}>
      <ListItem.CheckBox
        containerStyle={styles.checkbox}
        checked={isSelected}
        checkedIcon="check"
        uncheckedIcon=""
        title={
          store ? (
            <View style={styles.store}>
              <Text
                style={styles.name}
                numberOfLines={1}
              >{`${store.storeNumber} - ${store.name}`}</Text>
              <Text style={styles.text} numberOfLines={1}>
                {store.address}
              </Text>
            </View>
          ) : showAllStoresOptionName ? (
            <View style={styles.store}>
              <Text style={styles.name}>{showAllStoresOptionName}</Text>
            </View>
          ) : (
            ''
          )
        }
        disabled={!onSelect}
        onPress={
          onSelect && store
            ? () => {
                store && onSelect(store)
              }
            : undefined
        }
      />
    </ListItem>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    padding: 7,
  },
  checkbox: {
    backgroundColor: theme.colors?.white,
    borderWidth: 0,
    width: '100%',
  },
  store: {
    marginLeft: 7,
  },
  name: {
    fontSize: 13,
    fontFamily: font.bold,
    color: theme.colors?.black,
  },
  text: {
    fontSize: 13,
    color: theme.colors?.black,
  },
}))
